import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/index.css'
import './assets/pd-design-system.css'
import './assets/accessibility.css'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

axios.defaults.withCredentials = true
Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
